export default function PHP_rtrim() {
  return (
    <div>
      <h1>PHP_rtrim</h1>
    </div>
  );
}
